module.exports = __webpack_public_path__ + "static/media/promo-1.365a7011.png";